<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-end text-secondary pb-2">Nouveau message SMS</h3>
  </div>
  <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="mb-3 row">
        <label class="col-sm-1 col-form-label">À</label>
        <div class="col-sm-11">
          <ng-select formControlName="to" [items]="[to]" [clearable]="false" [class.is-invalid]="submitted && form.controls?.to?.invalid">
            <ng-template ng-label-tmp let-item="item">
              <span *ngIf="isPhoneContact(item)"
                ><strong>{{ item.name }}</strong
                >&nbsp;{{ item.phone | phone }}</span
              >
              <span *ngIf="isString(item)"
                ><strong>{{ item }}</strong></span
              >
            </ng-template>
          </ng-select>
          <small *ngIf="submitted && form.controls?.to?.errors?.required" class="form-text text-danger"
            >L'adresse du destinataire est obligatoire.</small
          >
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col-12">
          <textarea
            #tomessage
            class="form-control no-resize"
            [maxlength]="toMessageMaxlength"
            [rows]="6"
            formControlName="content"
            [class.is-invalid]="submitted && form.controls?.content?.invalid"
          ></textarea>
          <div class="d-flex">
            <small *ngIf="submitted && form.controls?.content?.errors?.required" class="form-text text-danger"
              >Le contenu du message est obligatoire.</small
            >
            <span class="ms-auto">{{ tomessage.value.length }}&nbsp;/&nbsp;{{ toMessageMaxlength }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row px-3">
      <div class="d-grid ms-lg-auto col-3 col-md-6 col-lg-3 mb-1">
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-3 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button class="btn btn-primary d-flex justify-content-center" type="submit">
          <fa-icon icon="comment"></fa-icon>
          <span class="ms-3 d-none d-md-block">Envoyer</span>
        </button>
      </div>
    </div>
  </form>
</div>
